import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader";
import { VRMLoaderPlugin } from "@pixiv/three-vrm";
import { VRMAnimationLoaderPlugin } from "@pixiv/three-vrm-animation";

/**
 * VRM/VRMA を読み込むためのプラグインを登録済みの GLTFLoader を生成する。
 */
export const makeGLTFLoader = (): GLTFLoader => {
  const loader = new GLTFLoader();
  // Register necessary plugins for VRM parsing
  loader.register((parser) => new VRMLoaderPlugin(parser));
  loader.register((parser) => new VRMAnimationLoaderPlugin(parser));
  return loader;
};

// Backwards-compatible singleton (still available for cases that want a shared loader)
const sharedGLTFLoader = makeGLTFLoader();
export default sharedGLTFLoader;
